import ContractAlias from "./ContractAlias";

export default ContractAlias;
